module.exports = __webpack_public_path__ + "static/Omoyeni-9d3be257533a54748884f931fd02bb46.jpeg";